// Topics.js
import React, { useEffect, useState } from "react";
import Input from "../../CoreComponent/Input";
import SVG from "react-inlinesvg";
import deleteIcon from "../../icons/deleteIcon.svg";

const Topics = ({
  topics = [],
  handleTopicChange,
  handleRemoveTopic,
  handleAddTopic,
}) => {
  const [approvedTopics, setApprovedTopics] = useState([]);

  useEffect(() => {
    const fetchSpeakerInfoAndTopics = async () => {
      const token = localStorage.getItem("token");

      try {
        // 1. Fetch speaker info
        const speakerResponse = await fetch(
          "https://eventscons.com/eventbackendnew/api/speakers/info",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              Accept: "application/json",
            },
          }
        );

        const speakerData = await speakerResponse.json();
        console.log("Speaker Info API Response:", speakerData);

        if (speakerData.speaker) {
          const { speaker_id, user_id, speaker_conference_id } = speakerData.speaker || {};

          if (speaker_id && user_id) {
            
            // alert(`Speaker ID: ${speaker_id}, User ID: ${user_id}, Conference ID: ${speaker_conference_id}`);

            // 2. Fetch approved topics
            const topicsResponse = await fetch(
              `https://eventscons.com/eventbackendnew/api/speakertopicsstatus?speaker_id=${speaker_id}&user_id=${user_id}&conference_id=62&status=approved`,
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  Accept: "application/json",
                },
              }
            );

            const topicsResult = await topicsResponse.json();
            console.log("Approved Topics API Response:", topicsResult);

            if (topicsResult.status && Array.isArray(topicsResult.data)) {
              setApprovedTopics(topicsResult.data);
            } else {
              alert("Topics API Error: " + (topicsResult.message || "Something went wrong"));
            }
          } else {
            alert("Speaker ID or User ID not found in response.");
          }
        } else {
          alert("Speaker Info Error: " + (speakerData.message || "Something went wrong"));
        }
      } catch (error) {
        alert("Fetch Error: " + error.message);
      }
    };

    fetchSpeakerInfoAndTopics();
  }, []);

  return (
    <div style={{ padding: "20px", border: "1px solid #eee", borderRadius: "8px" }}>
      {/* Approved Topics */}
      {approvedTopics.length > 0 && (
        <div style={{ marginBottom: "24px" }}>
          <div style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "12px", color: "#333" }}>
            Approved Topics:
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
            {approvedTopics.map((topicObj, idx) => (
              <div
                key={idx}
                style={{
                  border: "1px solid #d2d2d2",
                  borderLeft: "5px solid #4caf50",
                  padding: "12px 16px",
                  borderRadius: "8px",
                  backgroundColor: "#f9fff9",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <span style={{ fontWeight: 500, color: "#222" }}>{topicObj.topic_name}</span>
                <span
                  style={{
                    fontSize: "12px",
                    fontWeight: "bold",
                    padding: "4px 8px",
                    borderRadius: "20px",
                    backgroundColor: "#e6f4ea",
                    color: "#2e7d32",
                    border: "1px solid #2e7d32",
                  }}
                >
                  Approved
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default Topics;